module.exports = __webpack_public_path__ + "static/media/percentage.120f4deb.svg";